import * as types from './types';

export const setListSettings = (listName, settings) => ({
  type: types.LIST_SETTINGS_SET_DATA,
  listName,
  settings
});


// WEBPACK FOOTER //
// ./src/actions/list-settings/index.js